import { render } from "./SpotFlexiblePatternContainer.vue?vue&type=template&id=70b5946c&ts=true"
import script from "./SpotFlexiblePatternContainer.vue?vue&type=script&lang=ts"
export * from "./SpotFlexiblePatternContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__